"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var keccak_1 = __importDefault(require("keccak"));

var buffer_1 = require("../buffer");

function sha3() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return keccak_1.default('keccak256').update(Buffer.concat(args.map(function (arg) {
    return buffer_1.anyToBuffer(arg);
  }))).digest();
}

exports.sha3 = sha3;